import { render } from "./MentionsView.vue?vue&type=template&id=2ff4009e&scoped=true"
import script from "./MentionsView.vue?vue&type=script&lang=js"
export * from "./MentionsView.vue?vue&type=script&lang=js"

import "./MentionsView.vue?vue&type=style&index=0&id=2ff4009e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff4009e"]])

export default __exports__